import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Costa Rica (1-47)
import costarica1 from '../images/costarica1.jpeg';
import costarica2 from '../images/costarica2.jpeg';
import costarica3 from '../images/costarica3.jpeg';
import costarica4 from '../images/costarica4.jpeg';
import costarica5 from '../images/costarica5.jpeg';
import costarica6 from '../images/costarica6.jpeg';
import costarica7 from '../images/costarica7.jpeg';
import costarica8 from '../images/costarica8.jpeg';
import costarica9 from '../images/costarica9.jpeg';
import costarica10 from '../images/costarica10.jpeg';
import costarica11 from '../images/costarica11.jpeg';
import costarica12 from '../images/costarica12.jpeg';
import costarica13 from '../images/costarica13.jpeg';
import costarica14 from '../images/costarica14.jpeg';
import costarica15 from '../images/costarica15.jpeg';
import costarica16 from '../images/costarica16.jpeg';
import costarica17 from '../images/costarica17.jpeg';
import costarica18 from '../images/costarica18.jpeg';
import costarica19 from '../images/costarica19.jpeg';
import costarica20 from '../images/costarica20.jpeg';
import costarica21 from '../images/costarica21.jpeg';
import costarica22 from '../images/costarica22.jpeg';
import costarica23 from '../images/costarica23.jpeg';
import costarica24 from '../images/costarica24.jpeg';
import costarica25 from '../images/costarica25.jpeg';
import costarica26 from '../images/costarica26.jpeg';
import costarica27 from '../images/costarica27.jpeg';
import costarica28 from '../images/costarica28.jpeg';
import costarica29 from '../images/costarica29.jpeg';
import costarica30 from '../images/costarica30.jpeg';
import costarica31 from '../images/costarica31.jpeg';
import costarica32 from '../images/costarica32.jpeg';
import costarica33 from '../images/costarica33.jpeg';
import costarica34 from '../images/costarica34.jpeg';
import costarica35 from '../images/costarica35.jpeg';
import costarica36 from '../images/costarica36.jpeg';
import costarica37 from '../images/costarica37.jpeg';
import costarica38 from '../images/costarica38.jpeg';
import costarica39 from '../images/costarica39.jpeg';
import costarica40 from '../images/costarica40.jpeg';
import costarica41 from '../images/costarica41.jpeg';
import costarica42 from '../images/costarica42.jpeg';
import costarica43 from '../images/costarica43.jpeg';
import costarica44 from '../images/costarica44.jpeg';
import costarica45 from '../images/costarica45.jpeg';
import costarica46 from '../images/costarica46.jpeg';
import costarica47 from '../images/costarica47.jpeg';

function CostaRica() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    costarica1, costarica2, costarica3, costarica4, costarica5, costarica6, costarica7, costarica8, costarica9, costarica10,
    costarica11, costarica12, costarica13, costarica14, costarica15, costarica16, costarica17, costarica18, costarica19, costarica20,
    costarica21, costarica22, costarica23, costarica24, costarica25, costarica26, costarica27, costarica28, costarica29, costarica30,
    costarica31, costarica32, costarica33, costarica34, costarica35, costarica36, costarica37, costarica38, costarica39, costarica40,
    costarica41, costarica42, costarica43, costarica44, costarica45, costarica46, costarica47
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇨🇷 Costa Rica 2018 🇨🇷</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Costa Rica ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CostaRica;